/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

export { default as UserBubbleDefault } from './user-bubble.story';
export { default as UserBubbleAction } from './user-bubble-action.story';
export { default as UserBubbleLong } from './user-bubble-long.story';
export { default as UserBubbleAndFiles } from './user-bubble-and-files.story';

import { removeLicenseHeader } from '../../../_common/export-stories-utils';
import UserBubbleDefaultSrcRaw from './user-bubble.story?raw';
import UserBubbleActionSrcRaw from './user-bubble-action.story?raw';
import UserBubbleAndFilesSrcRaw from './user-bubble-and-files.story?raw';
import UserBubbleLongSrcRaw from './user-bubble-long.story?raw';

export const UserBubbleDefaultSrc = removeLicenseHeader(
  UserBubbleDefaultSrcRaw,
);
export const UserBubbleActionSrc = removeLicenseHeader(UserBubbleActionSrcRaw);
export const UserBubbleLongSrc = removeLicenseHeader(UserBubbleLongSrcRaw);
export const UserBubbleAndFilesSrc = removeLicenseHeader(
  UserBubbleAndFilesSrcRaw,
);
